/**
 * No-op : l'authentification est désormais portée par un cookie httpOnly
 * envoyé automatiquement par le navigateur via `withCredentials: true`.
 * Conservé pour ne pas casser les imports existants — peut être supprimé
 * une fois que tous les services auront été nettoyés.
 */
export default function authHeader() {
  return {}
}
